import { MoreVertRounded, OpenInBrowserRounded } from "@mui/icons-material";
import { Button, IconButton, Menu, MenuItem, Stack, useTheme } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { ShareButton, useDrawer } from "src/components";

interface Props {
  link: string;
  onDeleteClicked?: () => void;
}

const ItemDrawerTitle = ({ link, onDeleteClicked }: Props) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const { closeDrawer } = useDrawer();
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", width: "100%" }}>
      <Stack direction="row" spacing={0.5}>
        <Button
          variant="tertiary"
          startIcon={<OpenInBrowserRounded />}
          onClick={() => {
            navigate(link);
            closeDrawer();
          }}
        >
          Open Page
        </Button>
        <ShareButton variant="tertiary" href={`${window.origin}${link}`} />
      </Stack>
      {onDeleteClicked && (
        <IconButton
          size="small"
          onClick={(e) => {
            setMenuAnchor(e.currentTarget);
            e.stopPropagation();
          }}
        >
          <MoreVertRounded />
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={(e: React.PointerEvent) => {
              setMenuAnchor(null);
              e.stopPropagation();
            }}
          >
            <MenuItem
              onClick={(e) => {
                setMenuAnchor(null);
                e.stopPropagation();
                onDeleteClicked();
              }}
              sx={{ color: theme.palette.error.main }}
            >
              Delete
            </MenuItem>
          </Menu>
        </IconButton>
      )}
    </Stack>
  );
};

export { ItemDrawerTitle };
